/**
 * @file: 退款相关request
 */
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  applyRefund: {
    url: '/health/api/v1/nucleicAcid/refund/apply',
    method: 'POST'
  },
  refundProgress: {
    url: '/health/api/v1/nucleicAcid/refund/getDetail',
    method: 'GET'
  }
};

const patients = {
  async refundProgress(id) {
    try {
      const response: Response = await request(api.refundProgress, {
        id
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async applyRefund({ id, cancelReason, refundInstructions }) {
    try {
      const response: Response = await request(
        api.applyRefund,
        {},
        {
          id,
          cancelReason,
          refundInstructions
        }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default patients;
